import { createContext, useContext } from 'react';

const AuthProviderContext = createContext({});

export function useAuth() {
  return useContext(AuthProviderContext);
}

export default AuthProviderContext.Provider;